import React from 'react';

import fetch from './../../fetch';

import moment from 'moment';

import utils from './../../../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号'},
    {key:'employeeCode', label: '职工号'},
    {key:'realName', label: '姓名'},
    {key:'sex', label: '性别', render: (value) => value === 1 ? '男' : '女'},
    {key:'roleName', label: '角色'},
    {key:'orgName', label: '部门'},
    {key:'teacherPropertyName', label: '教师性质'},
    {key:'isEval', label: '是否参评', render: (value) => +value === 1 ? '参评' : '不参评'},
]);

/**
 * @method querySearchByName
 * @param {object} keywords
 * @return {promise}
 */
const querySearchByName = (keywords ={}) => {
    return fetch.post('employee/find/by/realname', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            value: d.employeeId,
            employeeNo: d.loginName,
            label: d.realName
        }));
    });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('second/credit/class/auth/employee/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.employeeId,
            checked: false,
            name: d.realName
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}


const queryPropertiesList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('platform/code/employee/property', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}


/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};



const getSelection =() => {
    return DataGrid.selections;
}

const getSelectionData =() => {
    return DataGrid.selectData;
}

export default {
    querySearchByName,
    querySearch,
    columns,
    onSelect,
    onSelectData,
    setRefresh,
    getSelection,
    getSelectionData,
    queryPropertiesList,
    // queryDegreeList,
}